import React, { useState, useEffect, useRef } from "react";
import ServiceItem from './ServiceItem';

const NvItem = (props) => {
    const [selectedItem, setSelectedItem] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const hasChildren = props.item.services?.length > 0;

    useEffect(() => {
        if(!!props.selectedItem && props.selectedItem != props.item.id) {
            setIsOpen(false);
        }
    },[props.selectedItem]);

    return (
        <>
            <div className='nv-item-wrapper'>  
                <a className='text-wrapper' href='#' onClick={(e)=> handleItemClick(e, props.item)}>
                    <span>{props.item.id}</span> <span>({props.item.serviceCount})</span>
                </a> 
                {
                    hasChildren &&
                    <span className={isOpen ? 'arrow-up-icon' : 'arrow-down-icon'}></span>
                }  
            </div>

            {
                hasChildren && isOpen &&
                <div className='item-list-wrapper'>
                    {
                        props.item.services?.map((service, index) => {
                            return <ServiceItem key={index} item={service} selectedItem={selectedItem} setSelectedItem={setSelectedItem} /> 
                        })
                    } 
                </div>
            }        
        </>
    );

    function handleItemClick(e, item) {
        e.preventDefault();

        if (hasChildren) {
            if (!isOpen) {
                props.setSelectedItem(item.id);
            }
            setIsOpen(!isOpen);
        }
    }

};

export default NvItem;
